const DEFAULT_ERROR = 'Request failed';

function supabaseConfig() {
  const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL || '').replace(/\/$/, '');
  const anonKey = String(import.meta.env.VITE_SUPABASE_KEY || '').trim();
  if (!supabaseUrl || !anonKey) {
    throw new Error('Missing Supabase configuration');
  }
  return { supabaseUrl, anonKey };
}

async function readBody(response) {
  const contentType = response.headers.get('Content-Type') || '';
  if (contentType.includes('application/json')) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }
  try {
    const text = await response.text();
    return text ? { message: text } : null;
  } catch {
    return null;
  }
}

function errorMessageFromBody(data, fallback) {
  if (!data || typeof data !== 'object') return fallback;
  return data.error || data.message || data.msg || fallback;
}

/**
 * Call Supabase REST / Edge Functions with the anon key only.
 * Share-link uploaders are not signed in; supabase-js invoke waits on
 * getSession() first and can hang forever if an expired/locked session exists.
 */
export async function anonSupabaseRequest(path, { method = 'POST', body } = {}) {
  const { supabaseUrl, anonKey } = supabaseConfig();
  const url = path.startsWith('http') ? path : `${supabaseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      apikey: anonKey,
      Authorization: `Bearer ${anonKey}`,
    },
    body: body == null ? undefined : JSON.stringify(body),
  });
  const data = await readBody(response);
  if (!response.ok) {
    throw new Error(errorMessageFromBody(data, `${DEFAULT_ERROR} (${response.status})`));
  }
  return data;
}

export async function functionsErrorMessage(error) {
  if (!error) return 'Failed to get S3 upload URL';
  const response = error.context;
  if (response && typeof response.json === 'function') {
    try {
      const cloned = typeof response.clone === 'function' ? response.clone() : response;
      const data = await cloned.json();
      return errorMessageFromBody(data, error.message || 'Failed to get S3 upload URL');
    } catch {
      /* ignore */
    }
  }
  return error.message || 'Failed to get S3 upload URL';
}
